import { logout } from "../app/Login/logout";

const baseUrl = process.env.NODE_ENV === "development" ? "http://localhost:3005" : "";

const originalFetch = window.fetch;

export class FetchError extends Error {
  constructor(
    public status: number,
    public message: string,
    public context?: any,
  ) {
    super(message);
  }
}

export type SuccessResponse<T> = {
  status: "success";
  data: T;
};

// TODO: refactor, too many arguments
export const fetch = async <T>(
  url: string,
  method: "GET" | "POST" | "PATCH" | "DELETE" | "PUT" = "GET",
  rawBody?: any,
  signal?: any,
  port?: number,
  contentType?: string,
) => {
  const base = port ? `http://localhost:${port}` : baseUrl;
  const input = `${base}${url}`;

  const body = rawBody && (rawBody instanceof FormData ? rawBody : JSON.stringify(rawBody));
  const headers = !(rawBody instanceof FormData)
    ? {
        "Content-Type": "application/json",
      }
    : undefined;

  const response = await originalFetch(input, {
    method,
    headers,
    credentials: "include",
    signal,
    body,
  });

  if (contentType === "text/csv") {
    const blob = await response.blob();
    if (response.status >= 400) {
      throw new FetchError(response.status, `Failed to fetch ${method} @ ${url}`);
    }
    return blob as unknown as T;
  }
  if (response.status === 204) {
    return null as T;
  }

  const data = await response.json();
  if (response.status === 401) {
    logout();
  }
  if (response.status >= 400) {
    let msg = `Failed to fetch ${method} @ ${url}`;
    if (data.message) {
      msg += `: ${data.message}`;
    }
    throw new FetchError(response.status, msg, data);
  }
  return data as T;
};

export { baseUrl as FETCH_BASE_URL };
